import { connect } from 'react-redux';
import IndicatorsDashbordInfo from '../../components/dashboard/indicatorsDashbord/Info/IndicatorsDashbordInfo';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorsDashbordInfo);
